export default __webpack_public_path__ + "static/media/fluent-emoji-flat_2nd-place-medal.0012824e.svg";